import clsx from 'clsx'
import {usePageData} from '@context/PageData'

/**
 * The current page's action buttons (Export, Create, …), set by the page through
 * <PageToolbarRight> in @context/PageData. They lived in the toolbar row until the sidebar layout
 * removed it; now they sit beside the page title — in the header on desktop, above the content below.
 */
const PageActions = ({className}: {className?: string}) => {
  const {rightContent} = usePageData()
  if (!rightContent) return null
  return (
    <div className={clsx('d-flex align-items-center flex-wrap gap-2', className)}>{rightContent}</div>
  )
}

export {PageActions}
